import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { PaymentManagementService } from '../payment-management.service';
import { saveAs } from 'file-saver/dist/FileSaver';
import { of } from 'rxjs';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import { Logo } from 'src/app/shared/logo-encode';
import THBText from 'thai-baht-text'
import pdfMake from 'pdfmake/build/pdfmake';
import { LogoChulaBlackWhite } from 'src/app/shared/logo-chula-black-white';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { Signature } from 'src/app/shared/signature';
import { WaterMark } from 'src/app/shared/water-mark';
import { OldChulaLogo_Base64 } from 'src/app/shared/old-chula-logo-base64';

@Component({
  selector: 'app-payment-detail',
  templateUrl: './payment-detail.component.html',
  styleUrls: ['./payment-detail.component.scss']
})
export class PaymentDetailComponent implements OnInit {

  pid;
  paymentDetail;
  payment;

  accountId: string = '';
  isPrint: boolean = false;
  receiptDetail: any;

  evidence = [];
  evidenceImage = [];
  evidenceFile = [];

  constructor(
    private paymentManagementService: PaymentManagementService,
    private router: Router,
    private route: ActivatedRoute,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.pid = new URL(location.href).searchParams.get('paymentId');
    this.accountId = new URL(location.href).searchParams.get('ACCOUNTING_ID');
    this.gobalFunctionService.setTitle('รายการทางการเงิน');
    // console.log(this.pid);

    this.paymentManagementService.getDetailPaymentById(this.pid).pipe(
      map(res => {
        this.payment = res.result;
        this.paymentDetail = res.result[0].Detail;
        // console.log(this.paymentDetail);
        // console.log(this.payment);
        let type;
        let evFile;

        evFile = this.paymentDetail.map(item => {
          const ev = item.EVIDENCE_DATA.map(evItem => {
            const fileType = evItem.EVIDEN_ORGINAL_NAME.split('.').pop();
            if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
              type = 'file';
            } else {
              type = 'image';
            }
            return {
              ID: evItem.ID,
              EVIDEN_FILE: evItem.EVIDEN_FILE,
              EVIDEN_ORGINAL_NAME: evItem.EVIDEN_ORGINAL_NAME,
              CREATE_DATE: evItem.CREATE_DATE,
              TRANS_ID: evItem.TRANS_ID,
              TYPE_FILE: type,
            }
          });
          return ev;
        });
        this.evidence = evFile;
        console.log(evFile);
        // this.evidence = this.paymentDetail[0].EVIDENCE_DATA.map(el => {
        //   const fileType = el.EVIDEN_ORGINAL_NAME.split('.').pop();
        //   if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
        //     type = 'file';
        //   } else {
        //     type = 'image';
        //   }
        //   return {
        //     ID: el.ID,
        //     EVIDEN_FILE: el.EVIDEN_FILE,
        //     EVIDEN_ORGINAL_NAME: el.EVIDEN_ORGINAL_NAME,
        //     CREATE_DATE: el.CREATE_DATE,
        //     TRANS_ID: el.TRANS_ID,
        //     TYPE_FILE: type,
        //   }
        // })

        // this.evidenceFile = this.evidence.filter((el) => el.TYPE_FILE === 'file');
        // this.evidenceImage = this.evidence.filter((el) => el.TYPE_FILE === 'image');

        // console.log(this.evidenceFile);
        // console.log(this.evidenceImage);
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }

  verify(p, t) {
    // console.log(p, t);

    const queryParams: Params = { paymentID: p, transId: t };
    this.router.navigate(
      ['/payment-management/payment-management-goverment/payment-verify'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });
  }

  download(file) {
    window.open(file, "_blank");
  }

  receipt(pid) {
    // console.log(pid);
    let receipt;

    this.paymentManagementService.getReceiptById(pid).pipe(
      map(res => {
        // console.log(res.result);
        if (res.success) {
          let printDate = new Date(res.result[0].PAYMENT_DATE)
          receipt = {
            address: ``,
            thbath: res.result[0].PAYMENT_PRICE > 0 ? THBText(res.result[0].PAYMENT_PRICE) : 'ศูนย์บาท',
            discount: res.result[0].PAYMENT_PRICE === res.result[0].STANDARTPRICE ? 0 : res.result[0].STANDARTPRICE - res.result[0].SPECIALPRICE,
            price: res.result[0].REMARK_PRICE ? res.result[0].REMARK_PRICE : res.result[0].PAYMENT_PRICE,
            standardPrice: res.result[0].STANDARTPRICE,
            specialPrice: res.result[0].SPECIALPRICE,
            type: res.result[0].PAYMENT_TYPE === '2C2P' ? 'บัตรเครดิต/เดบิต' : 'เงินโอน',
            paymentID: res.result[0].PAYMENT_ID,
            signaturePic1: Signature[0].signature,
            signatureName1: Signature[0].signatureName,
            signatureJobTitle1: Signature[0].position,
            signaturePic2: Signature[1].signature,
            signatureName2: Signature[1].signatureName,
            signatureJobTitle2: Signature[1].position,
            userName: res.result[0].NAME,
            userPhone: res.result[0].PHONENUMBER,
            taxID: res.result[0].TAX_NO,
            userAddress: res.result[0].ADDRESS,
            date: new DatePipe().transform(res.result[0].PAYMENT_DATE.toString(), 'full'),
            bankDate: new Date(res.result[0].PAYMENT_DATE),
            printDate: `${new DatePipe().transform(res.result[0].PAYMENT_DATE.toString(), 'full')} - ${printDate.getHours() > 9 ? '' : 0}${printDate.getHours()}:${printDate.getMinutes() > 9 ? '' : 0}${printDate.getMinutes()} น.`,
            paymentName: res.result[0].PAYMENT_NAME,
            receiptId: res.result[0].RECEIPT_ID,
            cardNo: res.result[0].CARD_NO,
          }

          this.receiptDetail = receipt;
          this.isPrint = true;
          setTimeout(() => {
            this.isPrint = false;
          }, 1000);

        }
      }),
      catchError((err) => {
        // console.log(err);
        alert(err.error.message);
        this.router.navigate(['/'])
        return of(null);
      }),
    ).subscribe();

  }
}
